import React from 'react';
import { Grid, Box, CircularProgress, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useGetOrderQuery } from 'state/api';
import { PageContainer } from 'components/shared';
import OrderSummary from './ordersummary';
import OrderItems from './orderitems';
import CustomerDetails from './customerdetails';
import ShippingDetails from './shippingdetails';
import BillingDetails from './billingdetails';
import OrderStatus from './orderstatus';

const DEFAULT_SUBTITLE = 'Review items, totals, customer and fulfillment status';

const OrderDetails = () => {
  const [params] = useSearchParams();
  const id = params.get('id');
  const { data, isLoading, isError } = useGetOrderQuery(id, { skip: !id });
  const order = data?.data;

  if (!id) {
    return (
      <PageContainer title="Order Details" subtitle={DEFAULT_SUBTITLE}>
        <Box sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h6" color="text.secondary">
            No order selected
          </Typography>
        </Box>
      </PageContainer>
    );
  }

  if (isLoading) {
    return (
      <PageContainer title="Order Details" subtitle={DEFAULT_SUBTITLE}>
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
          <CircularProgress />
        </Box>
      </PageContainer>
    );
  }

  if (isError || !order) {
    return (
      <PageContainer title="Order Details" subtitle={DEFAULT_SUBTITLE}>
        <Box sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h6" color="text.secondary">
            Order not found
          </Typography>
        </Box>
      </PageContainer>
    );
  }

  const subtitle = order.orderNumber
    ? `${order.orderNumber} · ${order.customer?.name || 'Walk-in'}`
    : DEFAULT_SUBTITLE;

  return (
    <PageContainer title="Order Details" subtitle={subtitle}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <OrderSummary order={order} />
          <OrderItems order={order} />
        </Grid>
        <Grid item xs={12} md={4}>
          <OrderStatus order={order} />
          <CustomerDetails order={order} />
          <ShippingDetails order={order} />
          <BillingDetails order={order} />
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default OrderDetails;
